

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const EntireAgreementSection = () => {
  return (
    <div>
      <Paragraph>
        This Agreement constitutes the complete and exclusive agreement between
        Customer and Club Sports Solutions L.L.C. regarding Customer's use of
        TrackBiz and supersedes all prior discussions, proposals, negotiations,
        representations, understandings, and agreements relating to the subject
        matter of this Agreement.
      </Paragraph>

      <Alert
        message="Entire Agreement"
        description="This Agreement replaces all prior verbal or written discussions regarding TrackBiz services provided to Customer."
        type="info"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        No amendment, modification, waiver, or addition to this Agreement shall
        be effective unless it is made in writing and approved by both parties.
      </Paragraph>

      <Paragraph>
        If any provision of this Agreement is determined to be invalid,
        unenforceable, or unlawful, the remaining provisions shall continue in
        full force and effect to the maximum extent permitted by law.
      </Paragraph>

      <Paragraph>
        The failure of either party to enforce any right or provision of this
        Agreement shall not constitute a waiver of that right or provision.
      </Paragraph>

      <Paragraph>
        This Agreement may be executed electronically and may be accepted through
        electronic signature platforms, including LegalZoom or similar services.
      </Paragraph>

      <Alert
        message="Electronic Signatures"
        description="Electronic signatures and electronic acceptance of this Agreement shall have the same legal effect as handwritten signatures."
        type="success"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        By proceeding with onboarding, Customer acknowledges that Customer has
        reviewed this Agreement, had the opportunity to ask questions, and agrees
        to be bound by its terms and conditions.
      </Paragraph>

      <Paragraph>
        <Text strong>
          After reviewing all sections, Customer must complete the final signature
          process through LegalZoom before activating the TrackBiz subscription.
        </Text>
      </Paragraph>
    </div>
  );
};

export default EntireAgreementSection;